import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Typography, Box, useTheme } from "@mui/material";

interface StatusCellProps {
    exists: boolean;
    yesText?: string;
    noText?: string;
    yesColor?: string;
    noColor?: string;
    yesIcon?: React.ReactNode;
    noIcon?: React.ReactNode;
    sx?: object;
}

const StatusCell: React.FC<StatusCellProps> = ({
    exists,
    yesText = "Yes",
    noText = "No",
    yesColor,
    noColor,
    yesIcon,
    noIcon,
    sx = {},
}) => {
    const theme = useTheme();
    const resolvedYesColor = yesColor || theme.palette.success.main;
    const resolvedNoColor = noColor || theme.palette.error.main;

    return (
        <Box sx={{ ml: 4, display: "flex", alignItems: "center", gap: 1, ...sx }}>
            {exists ? (
                <>
                    {yesIcon || <CheckCircleIcon sx={{ color: resolvedYesColor, fontSize: 20, opacity: 0.8 }} />}
                    <Typography fontWeight={500} color={resolvedYesColor}>{yesText}</Typography>
                </>
            ) : (
                <>
                    {noIcon ? (
                        React.cloneElement(noIcon as React.ReactElement, {
                            sx: { 
                                color: resolvedNoColor, 
                                fontSize: 20,
                                ...(noIcon as React.ReactElement).props?.sx
                            }
                        })
                    ) : (
                        <RemoveCircleOutlineIcon sx={{ color: theme.palette.text.disabled, fontSize: 20 }} />
                    )}
                    <Typography fontWeight={500} color={resolvedNoColor}>{noText}</Typography>
                </>
            )}
        </Box>
    );
};

export default StatusCell;